import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './assets/css/index.css';

// Ready to build!
ReactDOM.render(
  <App />,
  document.getElementById('root')
);
